export function grailPriceParts(product) {
  const managed = product.grail_managed === true;
  const base = typeof product.price === 'number' && Number.isFinite(product.price) ? product.price : null;
  if (!managed) return { managed, base, installation: null, total: null };
  const included = product.grail_installation_included === true;
  const cents = product.grail_installation_price_cents;
  const installation = included ? (Number.isInteger(cents) && cents >= 0 ? cents / 100 : null) : 0;
  return { managed, base, installation, total: base === null || installation === null ? null : Math.round((base + installation) * 100) / 100 };
}
export function grailDeliveryLabel(text) {
  return typeof text === 'string' ? text.replace(/^Auf Lager\b/i, 'Beim Hersteller auf Lager') : text;
}
